import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { BillingInterval } from "sdk/types";
import { priceFromCoupon } from "~/utils/couponCalculations";
import { Values } from "./types";

interface Props {
  billingInterval: BillingInterval;
  fullPrice: number;
}

export const ChargesNow: FC<Props> = ({ billingInterval, fullPrice }) => {
  const { t } = useTranslation();
  const {
    values: { coupon },
  } = useFormikContext<Values>();

  const actionStem = `planPayment.resubscribe` as const;
  const price = priceFromCoupon(fullPrice, coupon);

  return (
    <Flex direction="column" gap={3} w="full">
      <Flex direction="column" gap={2}>
        <Text variant="th-body2">{t(`${actionStem}.totalToday.label`)}</Text>
        <Text fontWeight="bold" variant="th-body1">
          {t(`${actionStem}.totalToday.amount`, { price })}
        </Text>
        <Text color="th.gray4" variant="th-body4">
          {t(`planPayment.billingInterval.${billingInterval}.renewal`)}
        </Text>
      </Flex>
    </Flex>
  );
};
